<!--
 * @Description: 打款总金额
 * @Date: 2020-12-12 16:02:25
-->
<template>
  <div>
    <div style="color: red">{{ formulaText }}</div>
    <table-render
      ref="tableRender"
      :config="config"
      height="35vh"
      width="80vw"
      @handleSearch="handleSearch"
    />
    <el-row type="flex" align="middle">
      <el-form :inline="true">
        <el-form-item style="margin-bottom:0" label="核算终端结算总金额：">
          <el-input
            :value="finishSumTaskPrice | moneyFixed"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          style="margin-bottom:0"
          label="项目支付金额（结算总价合计）："
        >
          <el-input :value="totalPrice | moneyFixed" disabled></el-input>
        </el-form-item>
      </el-form>
      <projectData
        :orderId="orderId"
        :type="type"
        :csoCustomOrderIds="csoCustomOrderIds"
      ></projectData>
      <div style="margin-left:15px;">
        <span>支付通道：{{ payBankText }}</span>
        <span style="margin-left:15px;">服务商付款方式：{{ payTypeText }}</span>
      </div>
    </el-row>
  </div>
</template>

<script>
import tableRender from '@/components/tableRender';
import projectData from './components/projectData';
import main from './config';
import { payBankFormatter, payTypeFormatter } from '@/common/fields/bank';

import { deepClone } from '@/tools';
import { editOperatorCommonFields } from '@/page/settlementCenter/utils/index.js';

export default {
  name: 'priceDetail',
  props: {
    // 订单ID或者ids
    orderId: {
      type: Number,
      default: 0,
      required: true
    },
    // 1未支付-全部未支付 2未支付-部分支付 3已支付 4失效
    type: {
      type: Number,
      default: 0,
      required: true
    },
    projectName: {
      type: String
    },
    csoCustomOrderIds: {
      type: String,
      default: ''
    },
    // 1自然人 3园区个体
    userEnterpriseType: {
      type: Number,
      default: 1
    },
    fullInfo: {
      type: Object
    }
  },
  data() {
    return {
      projectDataTable: [],
      config: null,
      csoCustomOrderSupplierId: '',
      getTotalPriceAjax: null, // 获取总价接口
      finishSumTaskPrice: '', //终端结算总金额合计
      totalPrice: '', // //结算总价合计
      payPassagewayCode: ''
    };
  },
  computed: {
    formulaText() {
      return this.userEnterpriseType === 3
        ? '【项目支付金额】计算公式为：结算总价 = 终端结算单价 * 任务量。项目支付金额为所有结算总价总和'
        : '【项目支付金额】计算公式为：结算总价=终端结算金额*(1+服务费率）。服务费率是完税成本。项目支付金额为所有结算总价总和';
    },
    payBankText() {
      return payBankFormatter(this.fullInfo);
    },
    payTypeText() {
      return payTypeFormatter(this.fullInfo);
    }
  },
  components: { tableRender, projectData },
  methods: {
    async handleSearch(v) {
      let { pdata } = await this.getTotalPriceAjax({
        ...v,
        orderId: this.orderId,
        csoCustomOrderIds: this.csoCustomOrderIds
      });
      Object.assign(this.$data, pdata);
    }
  },
  created() {
    const part = deepClone(main[this.type]);
    const currentFields = part.childMenu[0].fields;
    const currentSearch = part.childMenu[0].search;
    // 列表接口携带固定参数
    part.childMenu[0].defaultQuery = {
      orderId: this.orderId,
      // csoCustomOrderId: this.orderId,  // 已改为csoCustomOrderIds
      csoCustomOrderIds: this.csoCustomOrderIds
    };
    this.getTotalPriceAjax = part.childMenu[0].individualAjax;
    // 修改字段，适配个人、个体
    editOperatorCommonFields({
      currentFields,
      currentSearch,
      userEnterpriseType: this.userEnterpriseType
    });
    this.config = [part];
  }
};
</script>
